angular.module('registerAppServices', [])
    .service('regDataService', ['$http', '$q', function($http, $q) {
        var $service = this;

        $service.regData = {
            user: {},
            chain: {},
            branch: {},
            module: 'BOSS',
            positions: []
        };

        $service.submit = function() {
            var deferred = $q.defer();

            $http.post('/register', $service.regData).success(function (response) {
                deferred.resolve(response);
            });

            return deferred.promise;
        };
    }])
    .service('sendEmail', ['$http', '$q', function($http, $q) {
        var $service = this;

        $service.userData = {
            user: {}
        };

        $service.sendEmail = function(user) {
            var deferred  = $q.defer();
            var objToSend = {};

            if ( typeof user != "undefined" && user && $.trim(user.email) != '') {
                objToSend = {
                    email: user.email,
                    first_name:user.first_name,
                    last_name: user.last_name
                }
            }

            $http.post('/email', objToSend).success(function (response) {
                deferred.resolve(response);
            });

            return deferred.promise;
        };
    }])
    .service('checkCode', ['$http', '$q', function($http, $q) {
        var $service = this;

        $service.checkCode = function(email, code) {
            var deferred  = $q.defer();
            var objToSend = {};

            if ( typeof email != "undefined" && email && $.trim(email) != ''
                 && typeof code != "undefined" && code && $.trim(code) != ''
            ) {
                objToSend = {
                    email: email,
                    code:code
                }
            }

            $http.post('/check', objToSend).success(function (response) {
                deferred.resolve(response);
            });

            return deferred.promise;
        };
    }])
    .service('timezoneService', ['$http', '$q', function($http, $q) {
        var $service = this;
        $service.timezones = [];

        this.loadTimezones = function() {
            var deferred = $q.defer();

            $http.get('/get-timezones').success(function(response) {
                if(response.status) {
                    $service.timezones = response.data.timezones;
                    deferred.resolve(response.data.timezones);
                }
            });

            return deferred.promise;
        };

        this.getTimezoneNameByCode = function(timezoneCode) {
            var timezoneName = null;

            angular.forEach(this.timezones, function(timezone, code) {
                if(timezoneCode == timezone) {
                    timezoneName = code;
                }
            });

            return timezoneName;
        }
    }])
    .service('showPopupService', ['$http', '$q', '$window', '$rootScope', function($http, $q, $window) {

        var $service            = this;
        $service.obj            = {};
        $service.submitted      = false;

        $service.getPopup = function(){
            $window.onbeforeunload = function () {
                var emptyObject = $.isEmptyObject($service.obj);
                if ( (typeof $service.obj != "object" || !emptyObject) && $service.submitted == false ) {
                    return 'Leaving this page will erase all entered information defined. Continue?';
                }
            };
        }

    }])
    .service('geoService', ['$http', '$q', function($http, $q) {
        var $service = this;

        $service.countries = [];
        $service.regions   = [];
        $service.cities    = [];

        $service.countryTitle  = '';
        $service.countryCode   = '';
        $service.regionTitle   = '';
        $service.cityTitle     = '';
        $service.streetTitle   = '';
        $service.zipCode       = '';

        $service.loadCountries = function() {
            var deferred = $q.defer();

            $http.get('/get-countries').success(function(response) {
                if(response.status) {
                    $service.countries = response.data.records;
                    deferred.resolve(response.data.records);
                }
            });

            return deferred.promise;
        };

        //Added methods
        $service.setCountry = function(code, name, defaultLocale){
            var deferred = $q.defer();
            $http.post('/set-country', {
                country_code : code,
                country_title : name ,
                locale : defaultLocale
            }).success(function(response) {
                if(response.status) {
                    deferred.resolve(response.data);
                }
            });

            return deferred.promise;
        };

        /**
         *Передавать параметры с долготой/шириной
         */
        $service.getTimeZone = function(lat, long){
            var deferred  = $q.defer();
            $http.get(
                    'https://maps.googleapis.com/maps/api/timezone/json?location='
                       + lat + ',' + long +'&timestamp=1331161200&key=AIzaSyAObbmOETMCJrUPjeBozndTEKHmIOfPaus'

            ).success(function(response) {
                deferred.resolve(response);
            });
            return deferred.promise;
        }

        /**
         *
         * @param countryCode
         * @param name
         */
        $service.setRegion = function(countryCode, name){
            var deferred = $q.defer();
            $http.post('/set-region', {
                countryCode	 : countryCode,
                name	     : name
            }).success(function(response) {
                deferred.resolve(response.data);
            });

            return deferred.promise;

        };

        /**
         *
         * @param countryCode
         * @param regionId
         * @param name
         */
        $service.setCity = function(countryCode, regionId, name){
            var deferred = $q.defer();

            $http.post('/set-city', {
                countryCode	 : countryCode,
                regionId	 : regionId,
                name	     : name
            }).success(function(response) {
                if(response.status) {
                    deferred.resolve(response.data);
                }
            });

            return deferred.promise;
        };
        //Added methods

        $service.loadRegions = function(countryCode) {
            var deferred = $q.defer();

            $http.get('/get-regions', {
                params: {
                    country_code: countryCode
                }
            }).success(function(response) {
                if(response.status) {
                    $service.regions = response.data.records;
                    deferred.resolve(response.data.records);
                }
            });

            return deferred.promise;
        };

        $service.loadCities = function(regionId) {
            var deferred = $q.defer();

            $http.get('/get-cities', {
                params: {
                    region_id: regionId
                }
            }).success(function(response) {
                if(response.status) {
                    $service.cities = response.data.records;
                    deferred.resolve(response.data.records);
                }
            });

            return deferred.promise;
        };

        $service.getCountryNameByCode = function(countryCode) {
            var countryName = null;

            angular.forEach(this.countries, function(country) {
                if(countryCode == country.code) {
                    countryName = country.name;
                }
            });

            return countryName;
        };

        $service.getRegionNameById = function(regionId) {
            var regionName = null;

            angular.forEach(this.regions, function(region) {
                if(regionId == region.id) {
                    regionName = region.name;
                }
            });

            return regionName;
        };

        $service.getCityNameById = function(cityId) {
            var cityName = null;

            angular.forEach(this.cities, function(city) {
                if(cityId == city.id) {
                    cityName = city.name;
                }
            });

            return cityName;
        };


    }])
    .service('positionsService', ['$http', '$q', function($http, $q) {
        var $service = this;
        $service.positions = [];

        this.loadPositions = function(defaultLocale) {
            var deferred = $q.defer();

            $http.get('/get-positions', {
                params: {
                    default_locale: defaultLocale
                }
            }).success(function(response) {
                if(response.status) {

                    $service.positions = response.data.positions;
                    deferred.resolve(response.data.positions);
                }
            });

            return deferred.promise;
        };

        this.getPositionNamesByIds = function(positionIds) {
            var positionNames = [];

            angular.forEach(this.positions, function(position) {
                angular.forEach(positionIds, function(positionId) {
                    if(positionId == position.id) {
                        positionNames.push(position.name);
                    }
                });
            });

            return positionNames;
        };

    }])
    .service('businessService', ['$http', '$q', function($http, $q) {
        var $service = this;
        $service.businessTypes = [];

        this.loadBusinessTypes = function(){
            var deferred = $q.defer();

            $http.get('/get-business').success(function(response) {
                if(response.status) {
                    $service.businessTypes = response.data;
                    deferred.resolve(response.data);
                }
            });

            return deferred.promise;
        }
    }])
    .service('localeService', function() {
        this.locales = [
            {
                code: 'en_us',
                name: 'English'
            },
            {
                code: 'he_il',
                name: 'Hebrew'
            }
        ];

        this.getLocaleNameByCode = function(localeCode) {
            var localeName = null;

            angular.forEach(this.locales, function(locale) {
                if(localeCode == locale.code) {
                    localeName = locale.name;
                }
            });

            return localeName;
        };
    })
    .run(['geoService', function(geoService) {
        geoService.loadCountries();
    }]);